module.exports = __webpack_public_path__ + "img/136.8.1118ad72.png";